<template>
  <div class="main-container faq">
    <div class="row">
      <div class="col faq-accordion-holder">
        <h3 class="accordion-header" v-if="header">{{ header }}</h3>
        <div class="accordion accordion-flush" id="faq">
          <div class="accordion-item" v-for="(item, index) in faq" :key="index">
            <h3 :id="`flush-headin${index}`">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#flush-collapse${index}`"
                :aria-controls="`flush-collapse${index}`"
              >
                <span v-html="item.questionTitle"></span>
              </button>
            </h3>
            <div
              :id="`flush-collapse${index}`"
              class="accordion-collapse collapse"
              :aria-labelledby="`flush-headin${index}`"
              data-bs-parent="#faq"
            >
              <div class="accordion-body" v-html="item.questionAnswer">
              </div>
            </div>
          </div>
        </div>
        <div class="back-to-selection">
          <button @click.prevent="$emit('scroll-to', 'Policy Selection')" 
          class="btn btn-outline-primary px-3 py-2">Back to “Select your standing voting instruction”</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FAQ",
  data() {
    return {
      show: this.defaultOpen || false,
    };
  },
  props: {
    header: String,
    faq: [Array],
  },
};
</script>
<style lang="scss">
.main-container {
  font-family: var(--micrositeTypeStyle);

  &.faq {
    // background: unset !important;
    background-color: var(--background-3);
    padding: 40px 40px;

    @include media-breakpoint-down(lg) {
      padding: 32px 30px;
    }
     @include media-breakpoint-down(sm) {
      padding: 32px 24px;
    }
  }
}

.faq {
  .col {
    &.faq-accordion-holder {
      padding: 0;
    }
  }

  button.btn-outline-primary {
    @include primary-outline-btn();
    font-weight: 400;
  }
}

.faq .accordion-body {
  font-weight: 400;
  color: var(--primaryText);
}

.faq h2,
.faq h3 {
  color: var(--primaryText);
  font-weight: 700;
}
.faq h2 {
  font-size: 30px;
  line-height: 120%;
}
.accordion-body p {
  font-size: 16px;
  line-height: 150%;
}
.faq {
  h3.accordion-header {
    font-size: 30px;
    line-height: 150%;
    margin-bottom: 14px;
    
    @include media-breakpoint-down(sm) {
      font-size: 24px;
      margin-bottom: 0px;
    }
  }

  .accordion-button {
    font-size: 18px;
    line-height: 150%;
    color: var(--primaryText);
    @include media-breakpoint-down(sm) {
      // padding: 24px 0 !important;
    }
  }

  .accordion-button:not(.collapsed) {
    margin-bottom: 16px !important;    
  }

  .accordion-item {
    margin: 0 !important;
    padding: 32px 16px !important; 
    h3 {
      margin: 0;
    } 
    button > span {
      margin-right: 1rem;
    }
    @include media-breakpoint-down(sm) {
      margin: 0 !important;
      padding: 24px 0px !important;
    }
  } 
   
  .accordion-item:last-child {
    border-bottom: var(--bs-border-width) solid var(--bs-border-color) !important;
  }
}

.faq h3,
.faq .accordion-body {
  font-size: 16px;
  line-height: 150%;
}
.faq .accordion-button {
  // padding: 1rem 0;
  padding: 0;
  align-items: flex-start;

}
.faq h2,
.faq .accordion-body {
  padding: 0 17px;
  p {
    //  margin-left: 17px;
    //  margin-right: 17px;
  }
  
  p:last-child {
    margin-bottom: 0;
  }

  li:not(:last-child) {
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;    
    @include media-breakpoint-down(sm) {
      margin: 0;
    }
  }  

  ul li {
    display: flex;
  }

  ul li::before {
    content: "•";
    margin: 0 0.6rem;
    font-size: 1.2rem;
  }
} 

.faq .accordion-button {
  font-weight: normal;
}
.faq .accordion-button:not(.collapsed) span {
  font-weight: 700;
}

.faq .accordion-button:not(.collapsed) {
  background-color: #fff;
  color: var(--primaryText);
  box-shadow: none; 
}
.faq .accordion-button:focus {
  border-color: none !important;
  box-shadow: none !important;
}
.faq .accordion-button:focus-visible {
  border: 1px solid;
  box-shadow: none !important;
  color: $primary-text;
}

.faq .back-to-selection {
  padding-top: 30px;  
  @include media-breakpoint-down(sm) {
  padding-top: 24px;  
  button {  
      font-size:16px;
      height: auto;
    }  
  }
}
</style>
